<template>
  <div>
    <div class="espacio"></div>

    <!-- Encabezado -->
    <div class="mb-3">
      <div class="row">
        <div class="col-11">
          <div v-if="mensajeDetalle"
               class="form-control is-invalid d-inline-block"
               style="width:auto">
            {{ mensajeDetalle }}
          </div>
          <router-link
            v-if="p_EdadYears <= 5"
            class="btn btn-light"
            :to="{
              name: 'Crecimiento',
              query: {
                p_idAtencion, p_idPersona, p_numero,
                p_sexo, p_EdadYears, p_EdadMonths, p_EdadDays
              }
            }"
          >
            Curvas de Crecimiento
          </router-link>
        </div>
      </div>
    </div>

<Modal v-model:modelValue="showModalHelp" title="Ayuda — Constantes Vitales">
  <AyudaBiomAten />
</Modal>

    <!--  DataTable  -->
<DataTable
  :data="biomatens"
  :columns="columnas"
  idField="idBiomAten"
  :acciones="true"
  :mostrarBotonTodos="false"
  :mostrarBotonNuevo="false"
  :mostrarBotonExcel="false"
  :mostrarInfo="false"
  :mostrarEditar="estadoPermitido"
  :mostrarVer="false"
  :mostrarEliminar="false"
  mensajeVacio="No hay constantes vitales registradas."
  @refresh="cargarDatos()"
  @edit="({ idBiomAten, idBiometria }) => abrirModalEditar(idBiomAten, idBiometria)"
>
  <template #cell-valor="{ row }">
    <span class="text-end d-block">{{ row.valor }}</span>
  </template>
  <!-- Botón de ayuda -->
  <template #boton-ayuda>
    <button
      class="btn-help"
      type="button"
      title="Abrir ayuda de constantes vitales"
      @click="showModalHelp = true"
      aria-label="Abrir ayuda de constantes vitales"
    >
      <span class="material-symbols-outlined">help</span>
    </button>
  </template>
</DataTable>

    <!--  Modal editar biometría  -->
    <div class="modal fade" id="ventanaModal" tabindex="-1"
         aria-labelledby="modalBiomAtenLabel" aria-hidden="true"
         v-if="modalWindow">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white" id="modalBiomAtenLabel">{{ titulo }}</h5>
            <button type="button" class="btn-close btn-close-white"
                    data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body form-card">

            <!-- Métrica y edad -->
            <div class="mb-3">
              <div class="row align-items-center">
                <div class="col-1"><label class="form-label">Métrica</label></div>
                <div class="col-5">
                  <input type="text" class="form-control"
                         v-model="datoBiomAten.biometriaNombre" disabled>
                </div>
                <div class="col-1"><label class="form-label">Edad</label></div>
                <div class="col-5">
                  <input type="text" class="form-control" v-model="edadTexto" disabled>
                </div>
              </div>
            </div>

            <!-- Presión arterial (solo cuando idBiometria === 2) -->
            <div v-if="datoBiomAten.idBiometria === 2">
              <div class="mb-3">
                <div class="row align-items-center">
                  <div class="col-3">
                    <label class="form-label">Presión Arterial Sistólica</label>
                  </div>
                  <div class="col-2">
                    <input type="number" class="form-control"
                           v-model="presionSistolica.valor" required>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row align-items-center">
                  <div class="col-3">
                    <label class="form-label">Presión Arterial Diastólica</label>
                  </div>
                  <div class="col-2">
                    <input type="number" class="form-control"
                           v-model="presionDiastolica.valor" required>
                  </div>
                </div>
              </div>
            </div>

            <!-- Valor -->
            <div class="mb-3">
              <div class="row align-items-center">
                <div class="col-1"><label class="form-label">Valor</label></div>
                <div class="col-5">
                  <input v-if="datoBiomAten.idBiometria !== 2"
                         type="number" class="form-control"
                         v-model="datoBiomAten.valor" required>
                  <input v-else type="text" class="form-control"
                         v-model="datoBiomAten.valor" disabled>
                </div>
                <div class="col-6">
                  <label class="form-label fw-bold"
                         :style="{ color: resultadoColor }">
                    {{ resultadoCalculo }}
                  </label>
                </div>
              </div>
            </div>

            <!-- Descripción -->
            <div class="mb-3">
              <div class="row">
                <div class="col-12"
                     v-html="datoBiomAten.biometriaDescripcion"></div>
              </div>
            </div>

          </div>
          <div class="modal-footer">
            <button v-if="datoBiomAten.idBiometria === 7"
                    class="btn btn-outline-success"
                    @click="calcularIMC()">
              <span class="material-symbols-outlined"
                    style="font-size:32px;cursor:pointer">calculate</span>
              Calcular
            </button>
            <button v-if="btnEditar" type="button"
                    class="btn btn-success"
                    @click.prevent="guardarEditBiomAten()">
              <span class="material-symbols-outlined align-middle"
                    style="font-size:32px">update</span>
              Actualizar
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import AyudaBiomAten  from '@/views/ayuda/AyudaBiomAten.vue'
import DataTable      from '@/components/DataTable.vue'
import { validarForm } from '@/modules/validacionesForms.js'
import api            from '@/services/api'
import { openModal, closeModal } from '@/modules/modalHelper.js'
import swal           from 'sweetalert2'

export default {
  name: 'BiomAten',
  components: { AyudaBiomAten, DataTable },

  props: {
    p_idAtencion:    { type: Number, required: true },
    p_idPersona:     { type: Number, required: true },
    p_numero:        { type: Number, required: true },
    p_estadoAtencion:{ type: String, required: true },
    p_sexo:          { type: String, required: true },
    p_EdadYears:     { type: String, required: true },
    p_EdadMonths:    { type: String, required: true },
    p_EdadDays:      { type: String, required: true },
  },

  data() {
    return {
      biomatens:       [],
      datoBiomAten:    {},
      titulo:          '',
      btnEditar:       false,
      modalWindow:     true,
      mensajeDetalle:  '',
      showModalHelp:   false,
      edadTexto:       '',
      presionSistolica: {
        idBiomAten: 0, idAtencion: this.p_idAtencion,
        idBiometria: 13, valor: '', estado: 1,
      },
      presionDiastolica: {
        idBiomAten: 0, idAtencion: this.p_idAtencion,
        idBiometria: 14, valor: '', estado: 1,
      },

      //  Columnas para DataTable
      columnas: [
        { field: 'biometriaNombre', label: 'Descripción' },
        { field: 'valor',           label: 'Valor' },
      ],
    }
  },

  watch: {
    p_idAtencion(newVal, oldVal) {
      if (newVal !== oldVal) this.cargarDatos()
    }
  },

  computed: {
    estadoPermitido() {
      return ['PENDIENTE', 'PROCESO'].includes(this.p_estadoAtencion)
    },
    resultadoCalculo() {
      const v = this.datoBiomAten
      const map = {
        1:  () => this.evaluarTemperatura(v.valor),
        2:  () => this.evaluarPresionArterial(v.valor),
        3:  () => this.evaluarPulso(v.valor),
        4:  () => this.evaluarFrecuenciaRespiratoria(v.valor),
        5:  () => this.evaluarPeso(v.valor),
        6:  () => this.evaluarTalla(v.valor),
        7:  () => this.evaluarIMC(v.valor),
        8:  () => this.evaluarPerimetroAbdominal(v.valor),
        9:  () => this.evaluarHemoglobinaCapilar(v.valor),
        10: () => this.evaluarGlucosaCapilar(v.valor),
        11: () => this.evaluarPulsioximetria(v.valor),
        12: () => this.evaluarPerimetroCefalico(v.valor),
        13: () => this.evaluarPresionSistolica(v.valor),
        14: () => this.evaluarPresionDiastolica(v.valor),
      }
      return map[v.idBiometria]?.() ?? 'No disponible'
    },
    resultadoColor() {
      const r = this.resultadoCalculo
      if (r.includes('Normal') || r.includes('normal')) return 'green'
      if (r.includes('Leve') || r.includes('observación') || r.includes('alerta')) return 'orange'
      return 'red'
    },
  },

  mounted() {
    this.cargarDatos()
  },

  methods: {
    //  Carga de datos
    cargarDatos() {
      api.get(`/vwbiomatens/idatencion/${this.p_idAtencion}`)
        .then(response => { this.biomatens = response.data.reverse() })
        .catch(error   => console.error('Error cargando biometrías:', error))
    },

    //  Validación
    validarForm() {
      return validarForm(this.datoBiomAten, ['idBiometria'], ['idBiometria'])
    },

    //  Guardar
    async guardarEditBiomAten() {
      if (this.validarForm() !== 1) return

      if (this.datoBiomAten.idBiometria === 2) {
        try { await api.post('/biomatens', this.presionSistolica) }
        catch { swal.fire('Error!', 'Error al enviar la presión sistólica.', 'error') }

        try { await api.post('/biomatens', this.presionDiastolica) }
        catch { swal.fire('Error!', 'Error al enviar la presión diastólica.', 'error') }

        this.datoBiomAten.valor =
          `${this.presionSistolica.valor}/${this.presionDiastolica.valor}`
      }

      try {
        await api.post('/biomatens', this.datoBiomAten)
        closeModal('ventanaModal')
        this.cargarDatos()
      } catch (error) {
        swal.fire('Error!', 'Inténtelo de nuevo!', 'error')
        if (error.response?.data?.errors) {
          Object.values(error.response.data.errors).forEach(e => swal.fire(String(e)))
        }
      }
    },

    //  Abrir modal
    async abrirModalEditar(idBiomAten, idBiometria) {
      this.edadTexto = `${this.p_EdadYears} años, ${this.p_EdadMonths} meses, ${this.p_EdadDays} días`

      if (!['PENDIENTE', 'PROCESO'].includes(this.p_estadoAtencion)) {
        this.mensajeDetalle = `La acción no está permitida porque el estado es ${this.p_estadoAtencion}.`
        return
      }

      this.modalWindow = true

      if (idBiomAten) {
        if (idBiometria === 2) {
          const cargarPresion = async (idBiom, target) => {
            const { data } = await api.get(
              `/vwbiomatens/idatencion-idbiometria/${this.p_idAtencion}/${idBiom}`
            )
            if (data?.length) {
              const item = data[0]
              target.idBiomAten   = item.idBiomAten
              target.idAtencion   = item.idAtencion
              target.idBiometria  = item.idBiometria
              target.valor        = item.valor || ''
              target.estado       = item.estado
            }
          }
          await cargarPresion(13, this.presionSistolica)
          await cargarPresion(14, this.presionDiastolica)
        }

        const { data } = await api.get(`/vwbiomatens/${idBiomAten}`)
        this.datoBiomAten = data
      }

      this.titulo    = 'Constantes Vitales'
      this.btnEditar = true
      openModal('ventanaModal')
    },

    //  Calcular IMC
    calcularIMC() {
      api.post('/biomatens/calcularIMC', this.datoBiomAten)
        .then(response => { this.datoBiomAten.valor = response.data })
        .catch(() => swal.fire({
          icon: 'warning', title: 'Validación',
          text: 'Error de cálculo', confirmButtonText: 'Aceptar',
        }))
    },

    //  Evaluaciones clínicas (sin cambios)
    evaluarTemperatura(v) {
      if (v < 35.0)               return 'Hipotermia, requiere calentamiento rápido y evaluación médica'
      if (v <= 37.5)              return 'Temperatura normal'
      if (v <= 38.0)              return 'Fiebre leve, observar y tratar según síntomas'
      if (v <= 39.0)              return 'Fiebre moderada, requiere medicamentos antipiréticos y evaluación de causas'
      return                             'Fiebre alta, buscar atención médica inmediata'
    },
    evaluarPresionArterial(s, d) {
      if (s < 120 && d < 80)                                    return 'Presión arterial normal. Mantener estilo de vida saludable.'
      if (s >= 120 && s <= 129 && d < 80)                       return 'Elevación leve. Se recomienda un estilo de vida saludable.'
      if ((s >= 130 && s <= 139) || (d >= 80 && d <= 89))       return 'Hipertensión grado 1. Considerar modificaciones en el estilo de vida.'
      if ((s >= 140 && s <= 159) || (d >= 90 && d <= 99))       return 'Hipertensión grado 2. Probable necesidad de tratamiento farmacológico.'
      if (s >= 160 || d >= 100)                                  return 'Hipertensión grado 3. Evaluación médica urgente necesaria.'
      return 'Valores de presión arterial no reconocidos.'
    },
    evaluarPulso(v) {
      if (v < 60)    return 'Bradicardia, evaluar si hay síntomas asociados.'
      if (v <= 100)  return 'Pulso normal para adultos.'
      if (v <= 120)  return 'Levemente elevado, monitorizar y evaluar posibles causas.'
      return                'Taquicardia, requiere evaluación médica urgente.'
    },
    evaluarFrecuenciaRespiratoria(v) {
      if (v < 12)   return 'Bradipnea, evaluar si hay síntomas asociados.'
      if (v <= 20)  return 'Frecuencia respiratoria normal para adultos sanos.'
      if (v <= 24)  return 'Levemente elevada, monitorizar y evaluar posibles causas.'
      return               'Taquipnea, requiere evaluación médica urgente.'
    },
    evaluarPeso(v) {
      if (v < 50)   return 'Peso potencialmente bajo. Evaluar ingesta nutricional.'
      if (v <= 70)  return 'Peso normal. Mantener dieta balanceada y ejercicio regular.'
      if (v <= 90)  return 'Peso posiblemente en sobrepeso. Evaluar dieta y actividad física.'
      return               'Peso posiblemente obeso. Se recomienda evaluación médica.'
    },
    evaluarTalla(v) {
      if (v < 150)   return 'Estatura muy baja'
      if (v <= 159)  return 'Estatura baja'
      if (v <= 169)  return 'Estatura media'
      if (v <= 179)  return 'Estatura alta'
      return                'Estatura muy alta'
    },
    evaluarIMC(v) {
      if (v < 18.5)   return 'Bajo peso, posible riesgo de deficiencias nutricionales.'
      if (v <= 24.9)  return 'Normal, mantener un estilo de vida saludable.'
      if (v <= 29.9)  return 'Sobrepeso, mayor riesgo de enfermedades crónicas.'
      if (v <= 34.9)  return 'Obesidad grado I, alto riesgo de enfermedades metabólicas.'
      if (v <= 39.9)  return 'Obesidad grado II, muy alto riesgo.'
      return                 'Obesidad mórbida, evaluación médica intensiva recomendada.'
    },
    evaluarPerimetroAbdominal(v) {
      const limites = this.p_sexo === 'M' ? [94, 102] : [80, 88]
      if (v < limites[0])   return 'Normal'
      if (v <= limites[1])  return 'Riesgo aumentado, monitorización recomendada'
      return                       'Alto riesgo de problemas metabólicos y cardiovasculares.'
    },
    evaluarHemoglobinaCapilar(v) {
      if (v < 11)                               return 'Posible anemia, aumentar consumo de hierro y consultar especialista.'
      if (v <= 13)                              return 'Considerado bajo, monitorizar.'
      if (v <= 17 && this.p_sexo === 'M')       return 'Normal para hombres.'
      if (v <= 16 && this.p_sexo === 'F')       return 'Normal para mujeres.'
      if (v > 18)                               return 'Posible policitemia, evaluación médica recomendada.'
      return                                           'Fuera de parámetros, requiere evaluación adicional.'
    },
    evaluarGlucosaCapilar(v) {
      if (v < 70)    return 'Hipoglucemia, requiere atención inmediata.'
      if (v <= 99)   return 'Normal en ayunas.'
      if (v <= 125)  return 'Glucemia en ayunas alterada, monitorizar y consultar.'
      if (v <= 199)  return 'Glucemia postprandial alterada, ajustar dieta y monitorizar.'
      return                'Posible diabetes, consulta médica urgente.'
    },
    evaluarPulsioximetria(v) {
      if (v >= 95)  return 'Niveles normales de saturación de oxígeno'
      if (v >= 91)  return 'Observación, posible suplementación de oxígeno'
      if (v >= 86)  return 'Administración de oxígeno, considerar evaluación médica'
      return               'Emergencia médica, intervención inmediata necesaria'
    },
    evaluarPerimetroCefalico(v) {
      if (v < 32)   return 'Muy pequeño para la edad gestacional, evaluación médica recomendada.'
      if (v <= 36)  return 'Normal para recién nacidos.'
      return               'Grande para la edad gestacional, evaluar para descartar hidrocefalia.'
    },
    evaluarPresionSistolica(v) {
      if (v < 120)   return 'Presión arterial sistólica normal'
      if (v <= 129)  return 'Elevación leve, estilo de vida saludable recomendado'
      if (v <= 139)  return 'Hipertensión grado 1, cambios en estilo de vida recomendados'
      if (v <= 159)  return 'Hipertensión grado 2, tratamiento médico probablemente necesario'
      return                'Hipertensión grave, atención médica urgente necesaria'
    },
    evaluarPresionDiastolica(v) {
      if (v < 80)   return 'Presión arterial diastólica normal'
      if (v <= 84)  return 'Elevación leve, estilo de vida saludable recomendado'
      if (v <= 89)  return 'Hipertensión grado 1, considerar cambios en estilo de vida'
      if (v <= 99)  return 'Hipertensión grado 2, tratamiento médico necesario'
      return               'Hipertensión grave, atención médica urgente necesaria'
    },
  },
}
</script>

<style src="@/assets/css/listaFiltrada.css" scoped></style>
<style src="@/assets/css/tabla_estilizada.css" scoped></style>
<style src="@/assets/css/listaRegistros.css" scoped></style>
<style scoped>
.espacio { margin-top: 0.25em; }
.fila-interactiva { cursor: pointer; }
</style>
